// eslint-disable-next-line import/no-anonymous-default-export
export default [
  { id: 1, Topic: "Responsibilties", Date: "29-10-2021", Author: "Ananya" },
  { id: 1, Topic: "Financial issues", Date: "02-01-2022", Author: "Arpita" },
  { id: 1, Topic: "Work stress", Date: "08-08-2021", Author: "Ayushi" },
  {
    id: 1,
    Topic: "Emotional stability",
    Date: "17-05-2021",
    Author: "Prerana",
  },
];
